export default {
	install: Vue => {
		if ('serviceWorker' in navigator) {
			window.addEventListener('load', () => {
				navigator.serviceWorker.register('/src/modulos/core/static/notificaciones.js')
					.then(reg => {
						console.log('Se ha registrado el servicio correctamente')
						reg.update()
					}, err => {
						console.log(err)
						console.error('Error registrando el componente')
					})
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/libs/swFichar.js